import { useEffect } from "react";
import { Spinner } from "../components/loader/view/Loader";
import { clearPendingReturnUrl } from "../utils/postLoginRedirect";

// A full page load, not navigate(): the target (the user manual) is not part of this React app.
const ExternalRedirect = ({ to }) => {
    useEffect(() => {
        clearPendingReturnUrl();
        window.location.replace(to);
    }, [to]);
    return <Spinner fullPage />;
};

export default ExternalRedirect;
